/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import classnames from "gpages/utils/classnames"
import { useBrowserLayout } from "gpages/hooks/layout"
import { useScrollEvent } from "gpages/hooks/common"

import Nav from "@components/nav"
import Seo from "@components/seo"
import { wxConfig, wxShare } from "@src/utils/wechat"
import heroDesktop from "@images/hero-desktop.jpg"
import heroMobile from "@images/hero-mobile.jpg"

import * as styles from "./index.module.scss"
import AppContext from "@src/context/appContext"

const prepareImgs = [heroDesktop, heroMobile]
const loadingText = "LOADING".split("")
const minLoadingDuration = 2000
const maxLoadingDuration = 10000

const Layout = ({ children, location }) => {
  const [ready, setReady] = useState(false)
  const [scrolled, setScrolled] = useState(false)
  const { isAppLayout, isMobile, renderItem } = useBrowserLayout({
    appWidth: 1000,
  })

  useEffect(() => {
    wxConfig()
    wxShare()
  }, [])

  useEffect(() => {
    let mounted = true
    let count = 0
    let imagesReady = false
    let minDurationPassed = false
    const len = prepareImgs.length
    const finish = () => {
      if (mounted && imagesReady && minDurationPassed) {
        setReady(true)
      }
    }
    const counter = () => {
      count += 1
      if (count === len) {
        imagesReady = true
        finish()
      }
    }

    prepareImgs.forEach((src) => {
      const img = new Image()
      img.onload = counter
      img.onerror = counter
      img.src = src
    })

    const minTimer = setTimeout(() => {
      minDurationPassed = true
      finish()
    }, minLoadingDuration)
    const maxTimer = setTimeout(() => {
      imagesReady = true
      minDurationPassed = true
      finish()
    }, maxLoadingDuration)

    return () => {
      mounted = false
      clearTimeout(minTimer)
      clearTimeout(maxTimer)
    }
  }, [])

  useScrollEvent(
    () => {
      setScrolled(true)
    },
    { firstTrigger: false }
  )

  return (
    <AppContext.Provider
      value={{ isAppLayout, isMobile, renderItem, ready, scrolled }}
    >
      <Seo />
      <div
        className={classnames(styles.prepare, {
          [styles.prepareReady]: ready,
        })}
      >
        <div className={styles.loadingText} aria-label="Loading">
          {loadingText.map((letter, index) => (
            <span key={`${letter}-${index}`}>{letter}</span>
          ))}
        </div>
      </div>
      <div
        className={classnames(styles.main, {
          [styles.ready]: ready,
        })}
      >
        <Nav location={location} />
        <div
          className={classnames(styles.container, {
            [styles.mobile]: isAppLayout,
          })}
        >
          <main>{children}</main>
        </div>
      </div>
    </AppContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
